import PropTypes from 'prop-types';
import cn from 'classnames';
import Tooltip from 'infrastructure/js/components/tooltip/tooltip';
import {getCoCAttachmentAcceptTypes} from '../../utils/cocHelper';

import './cocAttachmentButton.scss';

const attachmentTypeIcons = {
  PDF: { icon: 'pl-file-pdf' },
  GRAPH: { icon: 'pl-file-graph' },
  CSV: { icon: 'pl-file-csv' },
  EXCEL: { icon: 'pl-file-excel' },
};

const getStatus = (attachmentsCount, attachmentsTotal) => {
  if (!attachmentsCount) {
    return '';
  }
  return (attachmentsCount < attachmentsTotal) ? 'fail' : 'pass';
}


export default function CoCAttachmentButton({
                                              id,
                                              type,
                                              tooltip = '',
                                              disabled = false,
                                              attachmentsTotal = 0 ,
                                              attachmentsCount = 0,
                                              onAttachmentChanged = null,
                                            }) {

  const onClickHandler = (e) => {
    e.target.value = '';
  }

  const onSelectedFileChanged = (e) => {
    if (e.target.files?.length > 0) {
      onAttachmentChanged?.(e.target.files[0], type);
    }
  };

  const isDisabled = (attachmentsTotal && attachmentsCount === attachmentsTotal) || disabled;
  return (
    <div className='coc-attachment-button'>
      <input type="file" id={id || 'fileChooser-' + type}
             disabled={isDisabled}
             multiple={false}
             className="input-file"
             accept={getCoCAttachmentAcceptTypes(type)}
             onClick={onClickHandler}
             onChange={onSelectedFileChanged}
      />

      <label key={type}
             className={cn('attach-button', getStatus(attachmentsCount, attachmentsTotal), {disabled: isDisabled})}
             htmlFor={id || 'fileChooser-' + type}>
        <Tooltip placement="top" value={tooltip || type}>
          <span className={`attach-button-icon pl ${attachmentTypeIcons[type]?.icon ?? ''}`} />
        </Tooltip>
        <span className="attach-button-label">{`${attachmentsCount}/${attachmentsTotal}`}</span>
      </label>
    </div>
  )
}

CoCAttachmentButton.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  attachmentsTotal: PropTypes.number ,
  attachmentsCount: PropTypes.number,
  onAttachmentChanged: PropTypes.func,
}
